var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagazineSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_6295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.067 0H7.93313C6.78321 0 5.85107 0.932238 5.85107 2.08206V31.5109L13.2849 22.7391C13.9091 22.0025 14.9579 21.7916 15.8182 22.2298L26.9585 27.904L34.8735 23.5135C35.7156 23.0466 36.7675 23.2176 37.418 23.9271L48.1492 35.6284V2.08206C48.1491 0.932238 47.217 0 46.067 0ZM39.127 18.282H14.8732C13.7234 18.282 12.7911 17.3497 12.7911 16.1999V9.02222C12.7911 7.8724 13.7234 6.94016 14.8732 6.94016H39.1268C40.2766 6.94016 41.2088 7.8724 41.2088 9.02222V16.2H41.2089C41.2089 17.3498 40.2768 18.282 39.127 18.282Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0101 32.0826C27.4046 32.4186 26.6718 32.4313 26.0552 32.1172L15.3965 26.6882L5.85107 37.9517V51.918C5.85107 53.0679 6.78331 54.0001 7.93313 54.0001H46.067C47.2169 54.0001 48.1491 53.0679 48.1491 51.918V41.7894L35.4582 27.9511L28.0101 32.0826ZM26.8102 46.7099H14.8732C13.7234 46.7099 12.7911 45.7777 12.7911 44.6278C12.7911 43.478 13.7234 42.5458 14.8732 42.5458H26.8102C27.9601 42.5458 28.8923 43.478 28.8923 44.6278C28.8923 45.7779 27.9603 46.7099 26.8102 46.7099ZM26.8102 40.5343H14.8732C13.7234 40.5343 12.7911 39.602 12.7911 38.4522C12.7911 37.3024 13.7234 36.3702 14.8732 36.3702H26.8102C27.9601 36.3702 28.8923 37.3024 28.8923 38.4522C28.8923 39.602 27.9603 40.5343 26.8102 40.5343Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_6295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazineSvgrepoCom1);
export default __webpack_public_path__ + "static/media/magazine-svgrepo-com 1.e3bf0e388d826873822c047f8b133c54.svg";
export { ForwardRef as ReactComponent };